var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.622 28.29C30.0204 27.892 30.5606 27.6685 31.1237 27.6685C31.6868 27.6685 32.2269 27.892 32.6253 28.29L40.332 35.9938L48.0387 28.29C48.2359 28.0928 48.47 27.9363 48.7276 27.8296C48.9853 27.7229 49.2615 27.668 49.5403 27.668C49.8192 27.668 50.0954 27.7229 50.353 27.8296C50.6107 27.9363 50.8448 28.0928 51.042 28.29C51.2392 28.4872 51.3956 28.7213 51.5024 28.9789C51.6091 29.2366 51.664 29.5128 51.664 29.7916C51.664 30.0705 51.6091 30.3467 51.5024 30.6043C51.3956 30.862 51.2392 31.0961 51.042 31.2933L43.3382 39L51.042 46.7066C51.4403 47.1049 51.664 47.6451 51.664 48.2083C51.664 48.7715 51.4403 49.3117 51.042 49.71C50.6437 50.1082 50.1036 50.332 49.5403 50.332C48.9771 50.332 48.4369 50.1082 48.0387 49.71L40.332 42.0061L32.6253 49.71C32.2271 50.1082 31.6869 50.332 31.1237 50.332C30.5604 50.332 30.0203 50.1082 29.622 49.71C29.2237 49.3117 29 48.7715 29 48.2083C29 47.6451 29.2237 47.1049 29.622 46.7066L37.3258 39L29.622 31.2933C29.2241 30.8949 29.0005 30.3548 29.0005 29.7916C29.0005 29.2285 29.2241 28.6884 29.622 28.29Z",
    fill: "#F26A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.83edcd5b2b9b4a51b0f6765962713b78.svg";
export { ForwardRef as ReactComponent };